import React, { useState } from 'react';
import './Navigation.css';

const Navigation = ({ onCourseSelect, selectedCourse, coursesList = [], coursesData = {} }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const handleCourseClick = (courseId) => {
    if (onCourseSelect) {
      onCourseSelect(courseId);
    }

    // Cerrar el menú en móviles después de seleccionar
    if (window.innerWidth <= 768) {
      setIsNavOpen(false);
    }

    // Desplazamiento suave a la sección correspondiente
    setTimeout(() => {
      const courseName = coursesData[courseId]?.name || courseId;
      const elementId = courseName.replace(/\s+/g, '-').toLowerCase();
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        // Enfocar el elemento para accesibilidad
        element.setAttribute('tabindex', '-1');
        element.focus({ preventScroll: true });
        setTimeout(() => element.removeAttribute('tabindex'), 1000);
      }
    }, 100);
  };

  const handleKeyDown = (e, courseId) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleCourseClick(courseId);
    }
  };

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  // Cerrar navegación con tecla Escape
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isNavOpen) {
        setIsNavOpen(false);
      }
    };

    if (isNavOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevenir scroll del body cuando el menú está abierto
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isNavOpen]);

  // Agrupar cursos por categoría
  const groupedCourses = React.useMemo(() => {
    const groups = {};

    coursesList.forEach(courseName => {
      const category = coursesData[courseName]?.category || 'SIN CATEGORIA';
      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push(courseName);
    });

    return groups;
  }, [coursesList, coursesData]);

  const categories = Object.keys(groupedCourses).sort();

  return (
    <>
      <button
        className={`mobile-menu-button ${isNavOpen ? 'open' : ''}`}
        onClick={toggleNav}
        aria-label={isNavOpen ? "Cerrar menú de navegación" : "Abrir menú de navegación"}
        aria-expanded={isNavOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div
        className={`overlay ${isNavOpen ? 'show' : ''}`}
        onClick={() => setIsNavOpen(false)}
        aria-hidden={!isNavOpen}
      ></div>

      <nav className={`navigation ${isNavOpen ? 'open' : ''}`}>
        <div className="nav-content">
          <h2 className="nav-title">Secciones</h2>

          {coursesList.length === 0 ? (
            <div className="no-courses">
              <p>No hay cursos disponibles</p>
            </div>
          ) : (
            <div className="courses-by-category">
              {categories.map((category) => (
                <div key={category} className="category-group">
                  <h3 className="category-title">{category}</h3>
                  <ul className="courses-list-simple">
                    {groupedCourses[category].map((courseId) => (
                      <li
                        key={courseId}
                        className={selectedCourse === courseId ? 'active' : ''}
                        onClick={() => handleCourseClick(courseId)}
                        onKeyDown={(e) => handleKeyDown(e, courseId)}
                        tabIndex={0}
                        role="button"
                        aria-label={`Seleccionar ${coursesData[courseId]?.name || courseId}${selectedCourse === courseId ? ' (actualmente seleccionado)' : ''}`}
                      >
                        {coursesData[courseId]?.name || courseId}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navigation;